import React from "react";
import Logo from "components/Logo";

import { Navigate } from "react-router-dom";

const Login = () => {
  const pharmaforce = sessionStorage.getItem("pharmaforce");
  const { access_token, profile } = JSON.parse(pharmaforce) || {};
    let userRoles = [];
const { roles } = profile || {};
  if (access_token) {
      let jwtData = access_token.split(".")[1];
      let decodedJwtJsonData = window.atob(jwtData);
      let decodedJwtData = JSON.parse(decodedJwtJsonData);
      userRoles = decodedJwtData["roles"];
      if (Array.isArray(userRoles)) {
        if (userRoles.includes("SUPADM") ||userRoles.includes("GWCPA") || userRoles.includes("GWCPU") || userRoles.includes("GWPFA") || userRoles.includes("GWTPAU"))
          return <Navigate to="/dashboard" />;
        else
          return <Navigate to="/purchase-orders" />;
      }
      else {
        if (access_token != undefined && decodedJwtData.roles != undefined && (decodedJwtData.roles === "SUPADM" || decodedJwtData.roles === "GWCPA" || decodedJwtData.roles === "GWCPU") || decodedJwtData.roles === "GWPFA" || decodedJwtData.roles == "GWTPAU")
          return <Navigate to="/dashboard" />;
        else
          return <Navigate to="/purchase-orders" />;
      }
    }
 
  return (
    <div className="h-90vh d-flex align-items-center justify-content-center">
      <div className="text-center">
        <Logo height={50} />
      </div>
    </div>
  );
};

export default Login;
